import {checkAuth} from 'shared/auth/actions';

import {navigateTo} from 'shared/actions';

import {
  setTitle,
  setSubTitle
} from 'shared/topBanner/actionTypes';

import {
  loadFinancialAccounts,
  completeCreateAccount
} from './accounts/actions';

import {
  loadFinancialAccountFees
} from './fees/actions';

export const handleFinanceHomeRouteEnter =  (nextState, replace, callback) => (dispatch)  =>
  dispatch(checkAuth(nextState, replace, callback))
    .then(() => {      
      dispatch(setTitle('Finance'));
      dispatch(setSubTitle(''));
      dispatch(loadFinancialAccounts());
      dispatch(loadFinancialAccountFees());
  })
  .catch(() => {});

  export const handleAccountCreatedRouteEnter =  (nextState, replace, callback) => (dispatch)  =>
  dispatch(checkAuth(nextState, replace, callback))
    .then(() => {
      dispatch(completeCreateAccount()).then(() => dispatch(navigateTo(`finance`)));
  })
  .catch(() => {});


// WEBPACK FOOTER //
// ./src/features/finance/actions.js